export class UserQuestionaire {
    questionaireDocId:string;
    responses:any[];
}